import { HouseDoor, Cart, Person, List } from "react-bootstrap-icons";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const BottomNav = ({ id_branch }) => {
  const cartItemsCount = useSelector((state) => state.cart.items.length);
  const dataUser = useSelector((state) => state.user.dataUser);

  const navItems = [
    { path: "/", icon: <HouseDoor size={24} />, label: "Home" },
    {
      path: `/cart/${id_branch}`,
      icon: (
        <span style={{ position: "relative", display: "inline-block" }}>
          <Cart size={24} />
          {cartItemsCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: -8,
                right: -10,
                background: "orange",
                color: "white",
                borderRadius: "50%",
                fontSize: 12,
                width: 18,
                height: 18,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              {cartItemsCount}
            </span>
          )}
        </span>
      ),
      label: "Compra",
    },
  ];

  // Solo mostrar "Pedidos" y "Perfil" si el usuario NO es cajero (role_id !== 3)
  // Convertir a número para asegurar comparación correcta
  const userRoleId = Number(dataUser?.role_id);

  if (userRoleId !== 3) {
    navItems.push(
      { path: "/orders", icon: <List size={24} />, label: "Pedidos" },
      { path: "/perfil", icon: <Person size={24} />, label: "Perfil" }
    );
  }

  return (
    <nav className="nav-bottom ">
      {navItems.map((item) => (
        <NavLink
          to={item.path}
          key={item.label}
          className={({ isActive }) =>
            `nav-bottom-items ${isActive ? "text-orange-500" : "text-gray-400"}`
          }
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
